import { API_V4 } from "@/services/config/auth-axios";

class AuthService {
  getAccessToken() {
    return localStorage.getItem("accessToken");
  }

  getOtpToken() {
    return localStorage.getItem("otpToken");
  }

  getGoogle2faToken() {
    return localStorage.getItem("google2faToken");
  }

  getListOfCountries() {
    return API_V4.get("/core/public/countries");
  }

  signIn(username, password, captcha_token, captcha_value) {
    return API_V4.post("/users/sign-in-user", {
      username,
      password,
      captcha_token,
      captcha_value
    });
  }
  verifyUserGoogle2fa(google2faToken, otp) {
    return API_V4.post("/users/two-factor-auth/google2fa/verify?version=2", {
      google2fa_token: google2faToken,
      otp: otp
    });
  }

  verifyUserOtp(otp, otpToken) {
    return API_V4.post("/users/two-factor-auth/otp/verify?version=2", {
      otp: otp,
      otp_token: otpToken
    });
  }

  resendLoginOtp(otpToken) {
    return API_V4.post("/users/two-factor-auth/otp/resend", {
      otp_token: otpToken
    });
  }

  verifyUserEmailOtp(otp, otpToken) {
    return API_V4.post("/users/two-factor-auth/email-otp/verify?version=2", {
      otp: otp,
      otp_token: otpToken
    });
  }

  resendLoginEmailOtp(otpToken) {
    return API_V4.post("/users/two-factor-auth/email-otp/resend", {
      otp_token: otpToken
    });
  }

  // REGISTRATION

  signUp(
    emailOrMobile,
    password,
    passwordConfirmation,
    termConfirmation,
    referralCode,
    captchaToken,
    captchaValue
  ) {
    return API_V4.post("/users/sign-up", {
      email_or_mobile: emailOrMobile,
      password: password,
      password_confirmation: passwordConfirmation,
      term_confirmation: termConfirmation,
      captcha_token: captchaToken,
      captcha_value: captchaValue,
      referral_code: referralCode
    });
  }

  verifyRegister(otp, otpToken, gacid, countryCode) {
    return API_V4.post("/users/verify/register", {
      otp: otp,
      otp_token: otpToken,
      google_analytics_client_id: gacid,
      country_code: countryCode
    });
  }

  resendRegisterOtp(otpToken) {
    return API_V4.post("/users/resend/register-otp", {
      otp_token: otpToken
    });
  }

  // PASSWORD

  recoverPassword(emailOrMobile, captchaToken, captchaValue) {
    return API_V4.post("/users/password/recover", {
      email_or_mobile: emailOrMobile,
      captcha_token: captchaToken,
      captcha_value: captchaValue
    });
  }

  passwordRecoveryOtp(otp, otpToken) {
    return API_V4.post("/users/password/recover/otp/verify", {
      otp: otp,
      otp_token: otpToken
    });
  }

  resetPassword(
    otpToken,
    password,
    passwordConfirmation,
    captchaToken,
    captchaValue
  ) {
    return API_V4.post("/users/password/reset/force", {
      otp_token: otpToken,
      password: password,
      password_confirmation: passwordConfirmation,
      captcha_token: captchaToken,
      captcha_value: captchaValue
    });
  }

  resendPasswordRecoveryOtp(otpToken) {
    return API_V4.post("/users/password/recover/otp/resend", {
      otp_token: otpToken
    });
  }
  captcha(type) {
    return API_V4.get(`/captcha/getAction/${type}`);
  }
  passwordRegex() {
    return API_V4.get("/users/password/regex");
  }
  userInfo() {
    return API_V4.get("/accounts/user-information");
  }
  signOut(data) {
    return API_V4.post("/users/sign-out", data);
  }
  deleteAccounts() {
    return API_V4.get("/users/delete-account");
  }

  getLoginSliders(type) {
    return API_V4.get(`/core/sliders?type=${type}`);
  }
  getRegisterSliders() {
    return API_V4.get("/core/sliders?type=desktop_register");
  }

  sendOtpToDisableGA(data) {
    return API_V4.post("/users/google2fa/send-otp", { ...data });
  }
  disableGA(data) {
    return API_V4.post("users/google2fa/remove", { ...data });
  }
}

export default new AuthService();
